class GwpSignIn extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      customerForm: '[js-customer-form]'
    }
  }

  connectedCallback() {
    if (this.dataset.currentPage == 'customers/register' || this.dataset.currentPage == 'customers/login') {
      this._addReturnToCartInput();
    }
  }

  _addReturnToCartInput = () => {
    const queryString = window.location.search;
    if (!queryString.includes('?return-to-cart')) {
      return;
    }

    const customerForm = document.querySelector(this._selectors.customerForm);
    const returnToCartInput = document.createElement('input');
    returnToCartInput.setAttribute('type', 'hidden');
    returnToCartInput.setAttribute('name', 'return_to');
    returnToCartInput.setAttribute('value', '/cart');
    customerForm.appendChild(returnToCartInput);
  }
}

if (!customElements.get('gwp-sign-in')) customElements.define('gwp-sign-in', GwpSignIn)
